// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['perfil_empresa_prana', 'comissao_avaliacao']



const DEFAULT_URL = '/perfil-empresa/v2'

const perfilEmpresaBreadCrumb = [
  {
    label: 'Home',
    to: 'Home'
  },
  {
    label: 'Perfil Empresa',
    to: 'perfilEmpresaV2'
  }
]

export default [
  {
    path: `${DEFAULT_URL}`,
    name: 'perfilEmpresaV2',
    component: () => import('@/views/V2/PerfilEmpresa/PerfilEmpresaListPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Perfil Empresa',
      breadcrumb: perfilEmpresaBreadCrumb
    }
  },
  {
    path: `${DEFAULT_URL}/:id/details`,
    name: 'perfilEmpresaV2Details',
    component: () => import('@/views/V2/PerfilEmpresa/NovoPerfilEmpresaPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Detalhes',
      breadcrumb: [
        ...perfilEmpresaBreadCrumb,
        {
          label: 'Detalhes do Perfil da Empresa',
          to: 'perfilEmpresaDetails'
        }
      ]
    }
  }
]
